module.exports = __webpack_public_path__ + "first-10-microprint.jpg?130d1e07b62126d54874dd4e5641ade6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-microprint.jpg
// module id = 403
// module chunks = 0